import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/loginSlice";
import quizReducer from "./slices/quizSlice";
import ticketReducer from "./slices/ticketSlice";
import walletReducer from "./slices/walletSlice";
import paymentReducer from "./slices/paymentSlice";
import userReducer from "./slices/userSlice";
import purchaseReducer from "./slices/purchaseTicketsSlice";
import luckyNumberReducer from "./slices/luckyNumberSlice";
import profileReducer from "./slices/profileSlice";
import totalTicketsAndWinReducer from "./slices/totalTicketsAndWinSlice";
import winnersReducer from "./slices/winnersSlice";
import withdrawReducer from "./slices/withdrawSlice";
import fcmTokenReducer from "./slices/fcmTokenSlice";
import ticketTimerReducer from "./slices/ticketTimerSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    quiz: quizReducer,
    tickets: ticketReducer,
    purchase: purchaseReducer,
    wallet: walletReducer,
    payment: paymentReducer,
    user: userReducer,
    luckyNumbers: luckyNumberReducer,
    profile: profileReducer,
    userTicketsAndWins: totalTicketsAndWinReducer,
    winners: winnersReducer,
    withdraw: withdrawReducer,
    fcmToken:fcmTokenReducer,
    ticketTimer: ticketTimerReducer,
  },
});

export default store;
